import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LoadingScreen } from "./LoadingScreen";
import { AppRoutes } from "../constants";
import type { BaseComponentProps } from "./base/BaseComponent";

interface ProtectedRouteProps extends BaseComponentProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading, authStatus } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (authStatus === "not_verified") {
    return (
      <Navigate
        to={AppRoutes.login}
        replace
        state={{ error: "NOT_VERIFIED" }}
      />
    );
  }

  if (authStatus === "needs_registration") {
    return (
      <Navigate
        to={AppRoutes.login}
        replace
        state={{ error: "NEEDS_REGISTRATION" }}
      />
    );
  }

  if (authStatus === "forbidden") {
    return (
      <Navigate to={AppRoutes.login} replace state={{ error: "FORBIDDEN" }} />
    );
  }

  if (!user) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  return <>{children}</>;
};
